import {api, routes} from "@/plugins/axios";

export function useLikes() {
    const createLike = (organizationSlug, articleUid) => {
        return api.post(routes.likes.create(organizationSlug, articleUid))
            .then((response) => {
                return Promise.resolve(response.data);
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    };

    const deleteLike = (organizationSlug, articleUID) => {
        return api.delete(routes.likes.delete(organizationSlug, articleUID))
            .then((response) => {
                return Promise.resolve(response.data);
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    }

    return {
        createLike,
        deleteLike
    }
}
